<template>
  <div class="animated fadeIn">
    <b-row class="mt-2 mb-2">
      <b-col>
        <h2>งานทั้งหมด</h2>
      </b-col>
    </b-row>
    <b-card>
      <b-row>
        <b-col>
          <b-table
            :items="quotes"
            :fields="tableFields"
            striped
            responsive="sm"
            :current-page="currentPage"
            :per-page="perPage"
            :tbody-tr-class="rowClass"
          >
            <template slot="goodsDescriptions" slot-scope="row">{{ row.item.goodsDescriptions }}</template>

            <template slot="shipper" slot-scope="row">{{ row.item.shipper ? row.item.shipper.name : '' }}</template>

            <template slot="startDate" slot-scope="row">{{ $moment(row.item.startDate).format('LL') }}</template>

            <template slot="createdAt" slot-scope="row">{{ $moment(row.item.createdAt).format('LLL') }}</template>

            <template slot="status" slot-scope="row">{{ jobStatus.find( x => x.value == row.item.status).text }}</template>

            <template slot="actions" slot-scope="row">
              <b-button
                variant="primary"
                size="sm"
                class="mr-1"
                :to="{name: 'รายละเอียดงาน', params: {quoteId:row.item._id}}"
                target="_blank"
              >จัดการ</b-button>
            </template>
          </b-table>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-pagination
            size="md"
            :total-rows="totalQuote"
            v-model="currentPage"
            :per-page="perPage"
            first-text="หน้าแรก"
            prev-text="หน้าที่แล้ว"
            next-text="หน้าถัดไป"
            last-text="หน้าสุดท้าย"
          ></b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <ModalLoading />
  </div>
</template>

<script>
import ModalLoading from '../../../components/ModalLoading'

import Quote from '../../../services/http/Quote'

export default {
  components: {
    ModalLoading
  },
  data () {
    return {
      tableFields: [
        { key: 'goodsDescriptions', label: 'ชื่องาน', class: 'text-center' },
        { key: 'shipper', label: 'ผู้ประกาศ', class: 'text-center' },
        { key: 'startDate', label: 'วันที่เริ่มงาน', class: 'text-center' },
        { key: 'createdAt', label: 'วันที่ประกาศ', class: 'text-center' },
        { key: 'status', label: 'สถานะ', class: 'text-center' },
        { key: 'actions', label: 'จัดการ' }
      ],
      quotes: [],
      totalQuote: 1,
      currentPage: 1,
      perPage: 10,
      filter: null,
      filterOn: [],
      jobStatus: [
        { value: '0', text: 'ร่าง', variant: 'info' },
        { value: '2', text: 'รอเผยแพร่', variant: 'info' },
        { value: '5', text: 'เผยแพร่', variant: 'primary' },
        { value: '7', text: 'มีคนส่งเอกสาร', variant: 'primary' },
        { value: '20', text: 'ปิดงาน', variant: 'success' }
      ]
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      Window.Event.$emit('showModalLoading')
      try {
        var quote = new Quote()
        var quotes = await quote.getQuoteAll()

        const sortDates = (a, b) => this.$moment(b.createdAt).format('YYYYMMDD') - this.$moment(a.createdAt).format('YYYYMMDD')

        let quoteList = quotes.data

        quoteList = quoteList.sort(sortDates)

        let availableJob = []
        let unavaliableJob = []
        for (let i = 0; i < quoteList.length; i++) {
          if (quoteList[i].status < 20) {
            availableJob.push(quoteList[i])
          } else {
            unavaliableJob.push(quoteList[i])
          }
        }

        this.quotes = availableJob.concat(unavaliableJob)
        this.totalQuote = this.quotes.length
      } catch (error) {
        console.log(error)
      }
      Window.Event.$emit('closeModalLoading')
    },
    rowClass (item, type) {
      if (!item) return

      if (item.status >= 20) {
        return ['bg-logisty-job-unavaliable', 'text-logisty-text-job-unavaliable']
        // return 'bg-white'
      } else {
        return 'bg-white'
      }
    }
  }
}
</script>
